export default "__VITE_ASSET__MfPSnTgg__"